import type { AuthCache } from "./cache";
import type { FrontendUser } from "./types";

// Minimal type declarations for browser storage (avoid DOM lib dependency)
interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: { localStorage?: StorageLike } | undefined;

function getLocalStorage(): StorageLike | undefined {
  if (window?.localStorage) {
    return window.localStorage;
  }
  return;
}

export function createLocalStorageCache(key: string): AuthCache {
  return {
    getUser(): FrontendUser | null {
      try {
        const storage = getLocalStorage();
        if (!storage) {
          return null;
        }
        const cached = storage.getItem(key);
        if (!cached) {
          return null;
        }
        return JSON.parse(cached) as FrontendUser;
      } catch {
        return null;
      }
    },
    setUser(user: FrontendUser | null): void {
      try {
        const storage = getLocalStorage();
        if (!storage) {
          return;
        }
        if (user) {
          storage.setItem(key, JSON.stringify(user));
        } else {
          storage.removeItem(key);
        }
      } catch {
        // Ignore storage errors (private browsing, quota exceeded)
      }
    },
  };
}
